import { DatePipe } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { Subscription } from 'rxjs';

import { TInnerBot } from '@core/interfaces/TBot';
import { TBotItem, TBotItemHistory } from '@core/interfaces/TBotItem';

import { SpinnerComponent } from '@shared/components/spinner/spinner.component';
import { BotsService } from '@shared/services/bots.service';
import { CommonService } from '@shared/services/common.service';

import { DateFromNowPipe } from '../../../../shared/pipes/date-from-now.pipe';
import { BotConfigComparisonComponent,TFieldSet } from './bot-config-comparison/bot-config-comparison.component';

@Component({
    selector: 'app-bot-config-history',
    templateUrl: './bot-config-history-modal.component.html',
    styleUrls: ['./bot-config-history-modal.component.scss'],
    standalone: true,
    imports: [
      MatAccordion,
      MatExpansionPanel,
      MatExpansionPanelHeader,
      MatExpansionPanelTitle,
      BotConfigComparisonComponent,
      MatButton,
      DatePipe,
      DateFromNowPipe,
      SpinnerComponent,
    ]
})
export class BotConfigHistoryModalComponent implements OnInit, OnDestroy {
  private _subs: Subscription[] = [];
  protected history: TBotItemHistory[] = [];
  protected isLoading = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { bot: TBotItem | TInnerBot; fieldSet: TFieldSet },
    private _dialogRef: MatDialogRef<BotConfigHistoryModalComponent>,
    private _botsService: BotsService,
    private _commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this._subs.push(
      this._botsService.getBotHistory(this.data.bot).subscribe(historyConfiguration => {
        this.history = historyConfiguration;
        this.isLoading = false;
      })
    );
  }

  ngOnDestroy(): void {
    this._subs.forEach(sub => sub.unsubscribe());
  }

  protected revertVersion(version: TBotItemHistory) {
    this._subs.push(
      this._botsService.restoreBotHistory(version).subscribe({
        next: () => {
          this.close();
          this._commonService.openSuccessSnackBar('Version reverted successfully');
        },
        error: () => {
          this._commonService.openErrorSnackBar('Version reverted failed');
        },
      })
    );
  }

  protected deleteVersion(version: TBotItemHistory) {
    this._subs.push(
      this._botsService.deleteVersion(version).subscribe({
        next: () => {
          this._commonService.openSuccessSnackBar('Version deleted successfully');
          this.history = this.history.filter(it => it._id !== version._id);
        },
        error: err => {
          console.error(err);
          this._commonService.openErrorSnackBar('Version deleted failed');
        },
      })
    );
  }

  close() {
    this._dialogRef.close();
  }
}
